import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  isInternalUser: boolean;
  constructor(private userService: UserService,
    private authService: AuthService,
    private router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authService.isAuthenticated()) {
      return true;
    } else {
      this.router.navigate(['/home']);
      return false;
    }
  }
}

@Injectable({
  providedIn: 'root'
})
export class V6AdminAuthGuard implements CanActivate {
  constructor(private userService: UserService, private authService: AuthService, private router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.authService.isAuthenticated()
      || !this.userService.isV6Admin()) {
      this.userService.UnAuthReq.next(true);
      this.router.navigate(['/unauthorized']);
      return false;
    } else {
      return true;
    }
  }

}

@Injectable({
  providedIn: 'root'
})
export class MarketingAdminAuthGuard implements CanActivate {
  constructor(private userService: UserService, private authService: AuthService, private router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authService.isAuthenticated()
      && this.userService.isMarketingAdmin()) {
      return true;
    } else {
      this.userService.UnAuthReq.next(true);
      this.router.navigate(['/unauthorized']);
      return false;
    }
  }

}
@Injectable({
  providedIn: 'root'
})
export class InvoiceInquiryAuthGuard implements CanActivate {
  constructor(private userService: UserService, private authService: AuthService, private router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authService.isAuthenticated()
      //&& this.userService.hasAccessToAccountSummary()
      && this.userService.hasAccessToInvoiceInquiry()
    ) {
      return true;
    } else {
      this.userService.UnAuthReq.next(true);
      this.router.navigate(['/unauthorized']);
      return false;
    }
  }

}
@Injectable({
  providedIn: 'root'
})
export class ManageCompanyAuthGuard implements CanActivate {
  constructor(private userService: UserService, private authService: AuthService, private router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authService.isAuthenticated()
      && this.userService.isVisibleManageCompany()) {
      return true;
    } else {
      this.userService.UnAuthReq.next(true);
      this.router.navigate(['/unauthorized']);
      return false;
    }
  }

}
@Injectable({
  providedIn: 'root'
})
export class AccountSummaryAuthGuard implements CanActivate {
  constructor(private userService: UserService, private authService: AuthService, private router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authService.isAuthenticated()
      && this.userService.hasAccessToAccountSummary()) {
      return true;
    } else {
      this.userService.UnAuthReq.next(true);
      this.router.navigate(['/unauthorized']);
      return false;
    }
  }

}
@Injectable({
  providedIn: 'root'
})
export class AdminMenuAuthGuard implements CanActivate {
  constructor(private userService: UserService, private authService: AuthService, private router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authService.isAuthenticated()
      && this.userService.hasAccessToAdminMenu()) {
      return true;
    } else {
      this.userService.UnAuthReq.next(true);
      this.router.navigate(['/unauthorized']);
      return false;
    }
  }

}
/*#region Sample Product Fulfillment*/

@Injectable({
  providedIn: 'root'
})
export class SampleProductAdminAuthGuard implements CanActivate {
  constructor(private userService: UserService, private authService: AuthService, private router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authService.isAuthenticated()
      && this.userService.isSampleProductAdmin()) {
      return true;
    } else {
      this.userService.UnAuthReq.next(true);
      this.router.navigate(['/unauthorized']);
      return false;
    }
  }

}
